
import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';
import { formatPhoneNumber } from '@/utils/phoneUtils';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';

interface PhoneDisplayProps {
  phoneNumber: string;
  isRevealed: boolean;
  autoReveal: boolean;
  isUserLoggedIn: boolean;
  isLoading?: boolean;
  onReveal: () => void;
}

const PhoneDisplay: React.FC<PhoneDisplayProps> = ({
  phoneNumber,
  isRevealed,
  autoReveal,
  isUserLoggedIn,
  isLoading = false,
  onReveal
}) => {
  const { t } = useTranslation();
  const { direction } = useDirection();
  const displayedPhone = formatPhoneNumber(phoneNumber);
  const buttonText = isLoading ? t('common.loading') : (isRevealed ? displayedPhone : t('phoneDisplay.viewPhone'));

  if (autoReveal && isUserLoggedIn && isRevealed) {
    return (
      <div className="flex items-center gap-2 text-green-600 font-medium">
        <Phone className="h-4 w-4" />
        {displayedPhone}
      </div>
    );
  }

  return (
    <Button
      onClick={onReveal}
      disabled={isLoading}
      className="w-full bg-[#00D09E] hover:bg-[#00C090] text-white disabled:opacity-50"
    >
      <Phone className={`h-4 w-4 ${direction === 'rtl' ? 'ml-2' : 'mr-2'}`} />
      {buttonText}
    </Button>
  );
};

export default PhoneDisplay;
